'use strict'
const noop_ = require('lodash/noop')
const remove_ = require('lodash/remove')

module.exports = (firePlatformEvent = noop_) => {

  let isDisposed = false
  let callbacks = {}

  const getCallbacks = eventName =>
    callbacks[eventName] ? callbacks[eventName] : (callbacks[eventName] = []) // WeakSet is not iterable.

  const register = (eventName, cb) => {
    if (isDisposed) {return noop_}

    getCallbacks(eventName).push(cb)
    return () => {remove_(getCallbacks(eventName), f => f === cb)}
  }

  const executeHooks = (eventName, ...args) => {
    return Promise.all(
      getCallbacks(eventName).map(cb => {
        try {
          return Promise.resolve(cb(...args))
        } catch (err) {
          return Promise.reject(err)
        }
      })
    )
  }

  const fireEvent = (eventName, ...args) => {
    firePlatformEvent(eventName, ...args)
    getCallbacks(eventName).forEach(cb => cb(...args))
  }

  const dispose = () => {
    isDisposed = true
    callbacks = {}
  }

  return {
    register,
    executeHooks,
    fireEvent,
    dispose
  }
}



// WEBPACK FOOTER //
// ./dataset-controller/eventListeners.js